import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  background-color: #F6F9FE;
  min-height: 100vh;
  padding-bottom: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
 background-color: #FFFFFF;
 width: calc(100% - 40px);
 height: auto;
 padding: 10px;
 margin: 20px 0px;
 border-radius: 8px;
 box-sizing: border-box;
 box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
`

const Title = styled.h3`
  width: calc(100% - 40px);
  font-size: 23px;
  font-weight: bold;
  color: #FF0066;
  margin-top: -15px;
  margin-bottom: 20px;
`;

const Text = styled.p`
  color: #808080;
`

const CenterColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0px 20px;
  margin-top: 50px;
  margin-bottom: 20px;
`;

const RedirectContainer = styled.div`
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 50px;
`;

export {
  Container,
  Content,
  CenterColumn,
  Title,
  Text,
  RedirectContainer,
};